import script from "./CustomerOrderDetailsSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerOrderDetailsSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerOrderDetailsSkeleton.vue?vue&type=style&index=0&id=697a623a&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-697a623a"]])

export default __exports__